import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "card border-0 shadow-none rounded-1 mb-25"
}
const _hoisted_3 = { class: "card-body p-xl-40 text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_QuotationForm = _resolveComponent("QuotationForm")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "edit_quotation",
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["items"]),
      (_ctx.isLoadingData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("quotation_page.loading_quotation_details")), 1)
          ]))
        : (_openBlock(), _createBlock(_component_QuotationForm, {
            key: 1,
            form: _ctx.form,
            customers: _ctx.customers,
            warehouses: _ctx.warehouses,
            "search-query": _ctx.searchQuery,
            "search-results": _ctx.searchResults,
            "show-results": _ctx.showResults,
            "total-items": _ctx.totalItems,
            "total-cost": _ctx.totalCost,
            "calculated-discount": _ctx.calculatedDiscount,
            "calculated-tax": _ctx.calculatedTax,
            "grand-total": _ctx.grandTotal,
            "is-submitting": _ctx.isSubmitting,
            "is-edit-mode": true,
            "warehouse-locked-to-profile": _ctx.warehouseLockedToProfile,
            onUpdateField: _ctx.handleUpdateField,
            onUpdateSearch: _ctx.handleSearchInput,
            onAddProduct: _ctx.addProduct,
            onUpdateQty: _ctx.updateQty,
            onSetQty: _ctx.updateItemQuantity,
            onRemoveItem: _ctx.removeItem,
            onSubmit: _ctx.submitQuotation
          }, null, 8, ["form", "customers", "warehouses", "search-query", "search-results", "show-results", "total-items", "total-cost", "calculated-discount", "calculated-tax", "grand-total", "is-submitting", "warehouse-locked-to-profile", "onUpdateField", "onUpdateSearch", "onAddProduct", "onUpdateQty", "onSetQty", "onRemoveItem", "onSubmit"])),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}